import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface SurveyOption {
  id: number;
  optionName: string;
}

export interface SurveySubmitPayload {
  referenceNo: string;
  rating: number;
  selectedOptionIds: number[];
  additionalComments?: string;
  type: string;
}

@Injectable({
  providedIn: 'root'
})
export class SurveyService {

  private baseUrl = environment.apiUrl + '/Survey';
  constructor(private http: HttpClient) {}

  getDeliveredOptions(): Observable<SurveyOption[]> {
    return this.http.get<SurveyOption[]>(`${this.baseUrl}/Options?type=delivered`);
  }  
  getPickupOptions(): Observable<SurveyOption[]> {
    return this.http.get<SurveyOption[]>(`${this.baseUrl}/Options?type=pickup`);
  }

  submitSurvey(payload: SurveySubmitPayload): Observable<any> {
    return this.http.post(`${this.baseUrl}/Submit`, payload);
  }

  getSurveyById(id: number): Observable<any> {
    return this.http.get(`${this.baseUrl}/${id}`);
  }

  getSurveyRecord(refno: string, type: string): Observable<any> {
    return this.http.get(`${this.baseUrl}/${refno}/${type}`);
  }
}